export default __webpack_public_path__ + "static/media/lucia.e58f6f87.jpg";